import React, { useState, useEffect } from 'react';
import { Menu, X, Instagram, MessageCircle } from 'lucide-react';
import { apartmentInfo, contactInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { href: '#galerija', label: 'Galerija' },
    { href: '#o-apartmanu', label: 'O apartmanu' },
    { href: '#lokacija', label: 'Lokacija' },
    { href: '#atrakcije', label: 'Atrakcije' },
    { href: '#faq', label: 'FAQ' },
    { href: '#kontakt', label: 'Kontakt' },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a
            href="#"
            className={`font-serif text-lg md:text-xl font-bold transition-colors duration-300 ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            <span className="block leading-tight">{apartmentInfo.name}</span>
            <span className="text-xs font-normal opacity-80">{apartmentInfo.subtitle}</span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => scrollToSection(e, item.href)}
                className={`text-sm font-medium transition-colors duration-300 hover:opacity-80 whitespace-nowrap ${
                  isScrolled ? 'text-gray-700 hover:text-sage-600' : 'text-white/90 hover:text-white'
                }`}
              >
                {item.label}
              </a>
            ))}
            
            {/* Social Icons */}
            <div className="flex items-center gap-2">
              <a
                href={contactInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className={`p-2 rounded-full transition-all duration-300 ${
                  isScrolled 
                    ? 'text-gray-700 hover:text-sage-600 hover:bg-sage-50' 
                    : 'text-white/90 hover:text-white hover:bg-white/10'
                }`}
                title="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href={`https://wa.me/${contactInfo.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className={`p-2 rounded-full transition-all duration-300 ${
                  isScrolled 
                    ? 'text-gray-700 hover:text-sage-600 hover:bg-sage-50' 
                    : 'text-white/90 hover:text-white hover:bg-white/10'
                }`}
                title="WhatsApp"
              >
                <MessageCircle size={20} />
              </a>
            </div>

            <a
              href="#rezervacija"
              onClick={(e) => scrollToSection(e, '#rezervacija')}
              className="bg-sage-600 hover:bg-sage-700 text-white px-5 py-2.5 rounded-lg text-sm font-medium transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              Rezerviraj
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <div className="lg:hidden flex items-center gap-2">
            {/* Mobile Social Icons */}
            <a
              href={contactInfo.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className={`p-2 rounded-full transition-all duration-300 ${
                isScrolled 
                  ? 'text-gray-700 hover:text-sage-600' 
                  : 'text-white/90 hover:text-white'
              }`}
            >
              <Instagram size={20} />
            </a>
            <a
              href={`https://wa.me/${contactInfo.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              className={`p-2 rounded-full transition-all duration-300 ${
                isScrolled 
                  ? 'text-gray-700 hover:text-sage-600' 
                  : 'text-white/90 hover:text-white'
              }`}
            >
              <MessageCircle size={20} />
            </a>
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`p-2 rounded-lg transition-colors ${
                isScrolled ? 'text-gray-900 hover:bg-gray-100' : 'text-white hover:bg-white/10'
              }`}
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 py-4 bg-white rounded-xl shadow-xl">
            <nav className="flex flex-col space-y-1">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => scrollToSection(e, item.href)}
                  className="px-4 py-3 text-gray-700 hover:bg-sage-50 hover:text-sage-600 transition-colors"
                >
                  {item.label}
                </a>
              ))}
              <div className="px-4 pt-2">
                <a
                  href="#rezervacija"
                  onClick={(e) => scrollToSection(e, '#rezervacija')}
                  className="block w-full bg-sage-600 hover:bg-sage-700 text-white px-5 py-3 rounded-lg text-center font-medium transition-all duration-300"
                >
                  Rezerviraj
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;